import {
  GLOBAL_TIME_FILTER,
  CLIENT_SESSIONS,
  CLIENT_FOLLOWUP,
  AVERAGE_SESSIONS,
  CLIENT_SESSIONS_LOADING,
  CLIENT_SESSIONS_ERROR,
  CLIENT_FOLLOWUP_LOADING,
  CLIENT_FOLLOWUP_ERROR,
  AVERAGE_SESSIONS_LOADING,
  AVERAGE_SESSIONS_ERROR,
  SESSION_SUMMARY,
  SESSION_SUMMARY_LOADING,
  SESSION_SUMMARY_ERROR,
  // DIAGNOSIS,
  // DIAGNOSIS_LOADING,
  // DIAGNOSIS_ERROR,
  OTHER_INFORMATION,
  OTHER_INFORMATION_LOADING,
  OTHER_INFORMATION_ERROR,
  UPDATE_BATCH_ACTION_STATUS,
  TIME_UTILISATION,
  TIME_UTILISATION_LOADING,
  TIME_UTILISATION_ERROR,
} from "../Actions/types";

const INITIAL_STATE = {
  timeFilter: "last_30_days",
  batchStatus: {
    type: null,
    recordId: null,
    successCount: 0,
    failedCount: 0,
  },
  clientSessions: {
    loading: false,
    data: {
      total_sessions: 0,
      first_session: {
        count: 0,
        percentage: 0,
      },
      repeat_session: {
        count: 0,
        percentage: 0,
      },
    },
    error: "",
  },
  clientFollowUp: {
    loading: false,
    data: {
      total_users: 0,
      one_session: {
        user_count: 0,
        percentage: 0,
      },
      two_sessions: {
        user_count: 0,
        percentage: 0,
      },
      three_sessions: {
        user_count: 0,
        percentage: 0,
      },
      four_plus_sessions: {
        user_count: 0,
        percentage: 0,
      },
    },
    error: "",
  },
  averageSessions: {
    loading: false,
    data: {
      average_sessions: 0,
    },
    error: "",
  },
  sessionSummary: {
    loading: false,
    data: {
      splitby_values: [],
      distribution: [],
    },
    error: "",
  },
  // diagnosis: {
  //   loading: false,
  //   data: [],
  //   error: "",
  // },
  timeUtilisation: {
    loading: false,
    data: {},
    error: "",
  },
  otherInformation: {
    loading: false,
    data: {
      nsp: {
        sent_count: 0,
        booked_count: 0,
        percentage: 0,
      },
      cpp: {
        sent_count: 0,
        booked_count: 0,
        percentage: 0,
      },
    },
    error: "",
  },
};

let analyticsNewReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // global time filter in header navbar
    case GLOBAL_TIME_FILTER:
      return {
        ...state,
        timeFilter: action.payload,
      };

    // batch status
    case UPDATE_BATCH_ACTION_STATUS:
      return { ...state, batchStatus: { ...action.payload } };

    // client sessions
    case CLIENT_SESSIONS_LOADING:
      return {
        ...state,
        clientSessions: { ...state.clientSessions, loading: action.payload },
      };
    case CLIENT_SESSIONS:
      return {
        ...state,
        clientSessions: { ...state.clientSessions, data: action.payload },
      };
    case CLIENT_SESSIONS_ERROR:
      return {
        ...state,
        clientSessions: { ...state.clientSessions, error: action.payload },
      };

    // client followup
    case CLIENT_FOLLOWUP_LOADING:
      return {
        ...state,
        clientFollowUp: { ...state.clientFollowUp, loading: action.payload },
      };
    case CLIENT_FOLLOWUP:
      return {
        ...state,
        clientFollowUp: { ...state.clientFollowUp, data: action.payload },
      };
    case CLIENT_FOLLOWUP_ERROR:
      return {
        ...state,
        clientFollowUp: { ...state.clientFollowUp, error: action.payload },
      };

    // average sessions
    case AVERAGE_SESSIONS_LOADING:
      return {
        ...state,
        averageSessions: { ...state.averageSessions, loading: action.payload },
      };
    case AVERAGE_SESSIONS:
      return {
        ...state,
        averageSessions: { ...state.averageSessions, data: action.payload },
      };
    case AVERAGE_SESSIONS_ERROR:
      return {
        ...state,
        averageSessions: { ...state.averageSessions, error: action.payload },
      };

    // session summary
    case SESSION_SUMMARY_LOADING:
      return {
        ...state,
        sessionSummary: {
          ...state.sessionSummary,
          loading: action.payload,
        },
      };
    case SESSION_SUMMARY:
      return {
        ...state,
        sessionSummary: {
          ...state.sessionSummary,
          data: action.payload,
        },
      };
    case SESSION_SUMMARY_ERROR:
      return {
        ...state,
        sessionSummary: {
          ...state.sessionSummary,
          error: action.payload,
        },
      };

    // time utilisation
    case TIME_UTILISATION_LOADING:
      return {
        ...state,
        timeUtilisation: {
          ...state.timeUtilisation,
          loading: action.payload,
        },
      };
    case TIME_UTILISATION:
      return {
        ...state,
        timeUtilisation: {
          ...state.timeUtilisation,
          data: action.payload,
        },
      };
    case TIME_UTILISATION_ERROR:
      return {
        ...state,
        timeUtilisation: {
          ...state.timeUtilisation,
          error: action.payload,
        },
      };

    // commented out for now
    // diagnosis
    // case DIAGNOSIS_LOADING:
    //   return {
    //     ...state,
    //     diagnosis: {
    //       ...state.diagnosis,
    //       loading: action.payload,
    //     },
    //   };
    // case DIAGNOSIS:
    //   return {
    //     ...state,
    //     diagnosis: {
    //       ...state.diagnosis,
    //       data: action.payload,
    //     },
    //   };
    // case DIAGNOSIS_ERROR:
    //   return {
    //     ...state,
    //     diagnosis: {
    //       ...state.diagnosis,
    //       error: action.payload,
    //     },
    //   };

    //other information
    case OTHER_INFORMATION_LOADING:
      return {
        ...state,
        otherInformation: {
          ...state.otherInformation,
          loading: action.payload,
        },
      };
    case OTHER_INFORMATION:
      return {
        ...state,
        otherInformation: {
          ...state.otherInformation,
          data: action.payload,
        },
      };
    case OTHER_INFORMATION_ERROR:
      return {
        ...state,
        otherInformation: {
          ...state.otherInformation,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default analyticsNewReducer;
